"use client";

import { useCallback } from "react";
import { useAuth } from "@hicya/auth-sdk/react";
import { AccountSection, Section } from "@hicya/ui";

import { LoadingRegion, Placeholder } from "@/components/layout/route-loading";
import { useDatabase } from "@/db/provider";

export function HabitsAccountSection() {
  const auth = useAuth();
  const db = useDatabase();

  const handleSignOut = useCallback(async () => {
    await db.clearSyncState();
    await auth.logout();
  }, [auth, db]);

  const handleDeleteAccount = useCallback(async () => {
    await auth.deleteAccount();
    await db.clearAllData();
  }, [auth, db]);

  if (auth.isLoading)
    return (
      <Section title="Account">
        <LoadingRegion label="Loading account">
          <Placeholder height={48} />
        </LoadingRegion>
      </Section>
    );

  return (
    <AccountSection
      user={auth.user ?? null}
      isAuthenticated={auth.isAuthenticated}
      isLoading={auth.isLoading}
      onSignIn={() => void auth.login({ provider: "google" })}
      onSignOut={handleSignOut}
      onDeleteAccount={handleDeleteAccount}
      signInSubtitle=""
    />
  );
}
